import { CapChartSecuritiesAccordionContent } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/CapChartSecuritiesDrawer/CapChartSecuritiesAccordionContent.tsx';
import { SecuritiesByTypeAccordion } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/CapChartSecuritiesDrawer/SecuritiesByTypeAccordion.tsx';
import { SecurityType } from '@dealstack/shared/lib/generated';
import { Accordion } from '@mantine/core';
import { memo, PropsWithChildren } from 'react';
import type { CapChartSecuritiesAccordionProps } from './CapChartSecuritiesAccordion.types';

const CapChartSecuritiesAccordion = ({
	person,
	personSecurities,
	selectedSecurities,
	setSelectSecurities,
}: PropsWithChildren<CapChartSecuritiesAccordionProps>) => {
	const allSecurities = Object.entries(personSecurities);
	return (
		<CapChartSecuritiesAccordionContent
			controlTitle={person.displayName}
			value={person.id}
			withBackground
		>
			<Accordion
				chevronSize="md"
				multiple
				defaultValue={allSecurities?.map(([type]) => type)}
			>
				{allSecurities?.map(([type, s]) => (
					<SecuritiesByTypeAccordion
						type={type as SecurityType}
						personSecurities={s}
						selectedSecurities={selectedSecurities}
						setSelectSecurities={setSelectSecurities}
						key={type}
					/>
				))}
			</Accordion>
		</CapChartSecuritiesAccordionContent>
	);
};

const Memoized = memo(CapChartSecuritiesAccordion);

export { Memoized as CapChartSecuritiesAccordion };
